/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
// import "@hennge/vue3-pagination/dist/vue3-pagination.css";
// import VPagination from "@hennge/vue3-pagination";
import createAssesment from "../createAssesment/createAssesment.vue"
import myAssesment from "../myAssesment/myAssesment.vue"
import TlAssesment from "../TlAssesment/TlAssesment.vue"

export default {
    components:{
        createAssesment,
        myAssesment,
        TlAssesment
      
    },
    data() {
        return {
          designationPrivileges: [],
          refreshFlags: {
            createAssesment: false,
            MyAssesment:false,
            TlAssesment:false
          }
        };
      },
      mounted(){
        this.designationPrivileges = store.getters.getRolesprivilegeData.split(",");
      },
      methods: {
        handleTabClick(tab) {
          this.refreshFlags[tab] = true;
          setTimeout(() => {
            this.refreshFlags[tab] = false;
          }, 100);
        },
        goBack() {
          this.$router.push(`/Assessment`);
        }
        
      }
    };